import { useState } from "react";
import type { GenerateMatrixResult } from "../domain/engine";
import { exportTests } from "../domain/export";
import { downloadFile } from "../lib/download";

interface ExportPanelProps {
  engineResult: GenerateMatrixResult;
}

export function ExportPanel({ engineResult }: ExportPanelProps) {
  const [status, setStatus] = useState<"idle" | "generating" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const disabled = engineResult.matrix.length === 0;

  function handleExport(format: "markdown" | "json") {
    setStatus("generating");
    setErrorMessage(null);
    try {
      const result = exportTests(
        engineResult.output.runId,
        engineResult.output.evidence.scenarioId,
        engineResult.matrix,
        engineResult.coverage,
        format,
      );
      downloadFile(result.filename, result.content, result.mimeType);
      setStatus("idle");
    } catch (error) {
      setStatus("error");
      setErrorMessage(error instanceof Error ? error.message : "No se pudo generar la exportación.");
    }
  }

  return (
    <div>
      <h3>Exportar evidencia</h3>
      <p className="field-hint">
        La exportación excluye payloads reales (los ejemplos son sintéticos) y redacta cabeceras
        sensibles antes de descargar.
      </p>
      <div className="action-row">
        <button type="button" className="button button-primary" disabled={disabled || status === "generating"} onClick={() => handleExport("markdown")}>
          Exportar Markdown
        </button>
        <button type="button" className="button button-secondary" disabled={disabled || status === "generating"} onClick={() => handleExport("json")}>
          Exportar JSON
        </button>
      </div>
      {status === "error" ? (
        <p className="field-error" role="alert">
          No pudimos generar la exportación ahora mismo. {errorMessage} Tus datos no se enviaron a ningún servidor; puedes reintentar.
        </p>
      ) : null}
    </div>
  );
}
